
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getProjectSupportingDocuments } from "../../../actions/projectActions";
import DataTablesSupportingDocs from "./DataTablesSupportingDocs";

const SupportingDocument = (props) => {

    const dispatch = useDispatch();
    const [searchInput, setSearchInput] = useState("")
    // const [projectId, setProjectId] = useState("")
    const [listSupportingDocsData, setSupportingDocsData] = useState()

    const { supportingDocs  } = useSelector(state => state.projectStore);
    
    useEffect(() => {
        if (props?.projectsId) {
            const project = props?.projectsId;
            // setProjectId(project)
            dispatch(getProjectSupportingDocuments(project ,searchInput))
        }
    }, [dispatch, searchInput , props.projectsId])


    useEffect(() => {
        setSupportingDocsData(supportingDocs)
    }, [supportingDocs])

    const handleChange = e => {
        if (e.target.name === 'searchInput') {
            setSearchInput(e.target.value)
        } else {
            setSearchInput('');
        }
    }
    return (
        <>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded flex_none pb-0">
                        <div className="row">
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <h2 className="text-white">Supporting Document</h2>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12 -right">
                                <div className="form-group relative_pos">
                                    <input type="text" 
                                    className="form-control text-white custom-placeholder custum-bg-warning" 
                                    name="searchInput"
                                    value={searchInput}
                                    onChange={handleChange}
                                    placeholder={'Search....'} />
                                    <span className="searchInput"><i className="icon-magnifier"></i></span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="body text-center card-body-shadow">
                        <DataTablesSupportingDocs data={listSupportingDocsData} />
                    </div>
                </div>
            </div>
        </>
    );
}
export default SupportingDocument;